import { useState } from 'react'
import { Stack } from '@chakra-ui/react'
import { CreateComment } from 'components/Notifications/CommunityBlogs/Comments/CreateComment'
import { CommentsForPost } from 'components/Notifications/CommunityBlogs/Comments/CommentsForPost'
import { COLORS } from 'utils/styles'
import { SUCCEEDED } from 'utils/constants'

export const Comments = ({
  activeProfile,
  chosenBlogIndex,
  comments,
  getCommentsStatus,
  postCommentsStatus,
  putCommentsStatus,
  blogParent,
  commentsOption,
  postsOption,
  widen,
  GoToMarker = false
}) => {
  const [editCommentData, setEditCommentData] = useState({})
  const parentData = blogParent[blogParent.length - 1]

  const handleMinHeight = () => {
    let wholeParent = document.querySelector('#chakra-modal-blog-drawer')
    const stickyHeader = document.querySelector('#stickyHeader' + blogParent[0]?.id)
    const minusToHeight = blogParent.length > 1 ? 5 : 30

    if (wholeParent && stickyHeader) {
      return wholeParent?.offsetHeight - stickyHeader?.offsetHeight - minusToHeight
    }

    wholeParent = document.querySelector('.leaflet-popup-content')
    if (wholeParent && stickyHeader) {
      return wholeParent?.offsetHeight - stickyHeader?.offsetHeight - minusToHeight
    }

    return '100svh'
  }

  return (
    <Stack
      key={parentData?.comment_id ?? parentData?.id}
      margin="-15px 0"
      padding="20px 5px 10px 5px"
      background={COLORS.darkGray}
      minHeight={handleMinHeight()}
    >
      <Stack overflow="hidden">
        {
          getCommentsStatus === SUCCEEDED || comments.length
            ? (
              <CreateComment
                activeProfile={activeProfile}
                blogParent={blogParent}
                getCommentsStatus={getCommentsStatus}
                type={commentsOption.type}
                postCommentsStatus={postCommentsStatus}
                putCommentsStatus={putCommentsStatus}
                editCommentData={editCommentData}
                setEditCommentData={setEditCommentData}
              />
            ) : ''
        }

        <CommentsForPost
          activeProfile={activeProfile}
          chosenBlogIndex={chosenBlogIndex}
          comments={comments}
          getCommentsStatus={getCommentsStatus}
          setEditCommentData={setEditCommentData}
          commentsOption={commentsOption}
          postsOption={postsOption}
          blogParent={blogParent}
          widen={widen}
          GoToMarker={GoToMarker}
        />
      </Stack>
    </Stack>
  )
}
